var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cigk2slafa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390 0v844H0V0h390z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cdink9usfb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.3.122 17.745 17.744a.417.417 0 0 1 0 .59l-.59.589a.417.417 0 0 1-.589 0L.122 1.3a.417.417 0 0 1 0-.59l.59-.589a.417.417 0 0 1 .589 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "xvzl2lgasc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.039.295a.417.417 0 0 1 .589 0l.59.589a.417.417 0 0 1 0 .59L1.472 19.216a.417.417 0 0 1-.59 0l-.588-.589a.417.417 0 0 1 0-.59z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cigk2slafa)",
    transform: "translate(-16 -66)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cdink9usfb)",
    transform: "translate(16.417 66.417)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C21",
    d: "M0 0h19.167v19.167H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#xvzl2lgasc)",
    transform: "translate(16.244 66.244)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C21",
    d: "M.173.173h19.166v19.166H.173V.173z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.14574966fc9cad2e20ca3b863c6e99ac.svg";
export { ForwardRef as ReactComponent };